import { render, staticRenderFns } from "./PublishCourse.vue?vue&type=template&id=a393f7f6&scoped=true&"
import script from "./PublishCourse.vue?vue&type=script&lang=js&"
export * from "./PublishCourse.vue?vue&type=script&lang=js&"
import style0 from "./PublishCourse.vue?vue&type=style&index=0&id=a393f7f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a393f7f6",
  null
  
)

export default component.exports